"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shoppingSessionContext = void 0;
var _react = require("react");
const shoppingSessionContext = exports.shoppingSessionContext = /*#__PURE__*/(0, _react.createContext)({
  isLoaded: false,
  isLoading: false,
  shoppingContext: undefined
});
